<div *ngIf="isInModal" class="{{ formControl.value ? 'text-success' : 'text-dark' }} font-size- fw-bold ">
  {{ placeHolder | translate }}
</div>

<modern-select
  [formControl]="formControl"
  [items]="internalItems"
  [placeHolder]="(!isInModal ? placeHolder : 'Select a value...') | translate"
  class="w-100"
>
</modern-select>

<hr *ngIf="isInModal" />
